import { ThemeService } from '@services/theme/theme.service';
import { UiService } from '@services/ui/ui.service';
import { LabelsService } from '@services/labels/labels.service';
import { AuthService } from '@services/auth/auth.service';
import { Injectable } from '@angular/core';
import { DeviceService } from '@services/device/device.service';
import { IdleService } from '@services/idle/idle.service';
import { ContentService } from '@services/content/content.service';
import { PushNotificationsService } from '../push-notifications/push-notifications.service';

@Injectable({
  providedIn: 'root'
})
export class BootstrapService {
  constructor(
    private authService: AuthService,
    private labels: LabelsService,
    private uiService: UiService,
    private themeService: ThemeService,
    private deviceService: DeviceService,
    private idleService: IdleService,
    private contentService: ContentService,
    private pushNotificationsService: PushNotificationsService
  ) {}

  bootstrap(): void {
    this.labels.loadOpenLabels().subscribe();
    this.authService.addActionAfterLogon(this.labels.loadLabels());
    this.authService.addActionAfterLogon(() =>
      this.themeService.setCompanyTheme()
    );
    this.uiService.ensureFullscreen();
    this.uiService.ensureOverlayClosingOnPageChange();
    this.deviceService.listenConnectionLoss();
    this.idleService.listenIdle();
    this.contentService.listenContentPage();
    this.contentService.listenNavigationEnd();
    this.pushNotificationsService.initPushNotifications();
  }
}
